import Logo from "../../assets/convolution-logo.svg";
import LinearProgress from "@mui/material/LinearProgress";
import { BookOpen, GraduationCap, Lightbulb, Globe } from "lucide-react";

export default function InitialPage() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen px-6 text-center bg-[#F5F7FA] overflow-hidden">

      <BookOpen className="text-blue-300 w-8 h-8 absolute top-10 left-10 animate-float-slow" />
      <GraduationCap className="text-yellow-400 w-8 h-8 absolute bottom-20 right-12 animate-float-medium" />
      <Lightbulb className="text-purple-300 w-8 h-8 absolute top-24 right-16 animate-float-fast" />
      <Globe className="text-green-400 w-10 h-10 absolute bottom-10 left-16 animate-float-slow" />

      <img src={Logo} alt="Logo" className="w-48 mb-8 z-10" />

      <p className="text-xl font-medium text-gray-800 mb-4 z-10">
        Hang tight, we are uploading all the knowledge so you can start learning right away!
      </p>

      <div className="w-full max-w-md mt-6 mb-10 z-10">
        <p className="text-sm text-gray-700 mb-2 pb-2 font-medium">
          37% 1.3GB out of 3.5GB
        </p>
        <LinearProgress
          variant="indeterminate"
          sx={{
            backgroundColor: "#E0E0E0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#2D72FE",
            },
            height: "10px",
            borderRadius: "6px",
            animationDuration: "3s",
          }}
        />
      </div>

      <p className="text-sm text-gray-600 z-10">
        You’re free to switch apps or lock your screen. <br />
        We’ll notify you once everything’s ready to begin learning.
      </p>
    </div>
  );
}
